<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon">
      <i class="fi fi-ss-search-alt"></i>
      {{"MSDCSearch.Header" | translate}}
    </span>
  </h1>
</div>

<p-card>
  <p-accordion>
    <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
      <form [formGroup]="searchForm">
        <div class="p-fluid formgrid grid">
          <div class="col-3">
            <label>
              <span class="requiredStart">*</span>
              {{ 'MSDCSearch.Search.Plant' | translate }}
            </label>
            <laas-plant-dropdown
              [isSingle]="true"
              formControlName="plant">
            </laas-plant-dropdown>
          </div>

          <div class="col-3">
            <label>{{ 'MSDCSearch.Search.ScanId' | translate }}</label>
            <input pInputText type="text" formControlName="scanId">
          </div>

          <div class="col-12 md:col-6 lg:col-3 mb-3">
            <label>{{ 'MSDCSearch.Search.SKU' | translate }}</label>
            <input type="text" pInputText formControlName="sku"/>
          </div>

          <div class="col-12 md:col-6 lg:col-3 laas-calendar">
            <laas-calendar
                #createDt
                [title]="'Common.Label.CreateDate'"
                [defaultDate]="defaultCreateDt"
                [enableMaxDateIsToday]="true"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event,'createDt')"
                [monthRange]="999"
                dateFormat="yy-mm-dd">
            </laas-calendar>
          </div>

          <div class="field col-12">
            <small><strong class="p-invalid">
              {{ 'MSDCSearch.Message.NotificationOfQuery' | translate }}
             </strong></small>
          </div>

        </div>


        <div>
          <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick($event)">
          </button>
          <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" type="reset"
            class="p-button-secondary ml-2">
          </button>
          <button pButton pRipple label="{{ 'FSCSSCSetting.Button.Export' | translate }}" [disabled]="tableValue.length === 0" (click)="exportBtnClick($event)" class="ml-2"></button>
        </div>

      </form>
    </p-accordionTab>
  </p-accordion>


  <div class="mt-2">

    <laas-data-table
            #MSDCDataTable
            [tableKey]="preferenceKey"
            [(selectedRows)]="selectRow"
            [defaultColumns]="tableColumns"
            [value]="tableValue"
            [totalRecords]="this.pageInfo.totalRecords"
            dataKey="rowId"
            (tableOnPage)="this.tablePageChange($event)"
            (tableOnSort)="this.tableSort($event)"
            [loading]="isLoading"
            [lazy]="true"
            (setPageSize)="setPageSize($event)"
            [rows]="5"
            styleClass="datatable-gridlines datatable-striped mt-2 white-space: nowrap;">

            <ng-template  pTemplate="body" let-columns="columns" let-rowData>

                <td *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.field">

                        <ng-container *ngSwitchDefault class="p-fluid">

                           <ng-container [ngSwitch]="col.dataType">
                              <ng-container *ngSwitchDefault>
                                <div class="overflow-text">
                                    {{ rowData[col.field] | replaceNullWith:'-'}}
                                </div>
                            </ng-container>

                              <ng-container *ngSwitchCase="'date'">
                                <div class="overflow-text">
                                  {{ rowData[col.field] | date: "yyyy-MM-dd HH:mm:ss":this.laasSetting.facilityTimeZone | replaceNullWith: "-" }}
                                </div>
                              </ng-container>
                            </ng-container>
                        </ng-container>


                    </ng-container>
                </td>

            </ng-template>

        </laas-data-table>

    </div>

</p-card>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
